import { render, staticRenderFns } from "./judgesEvaluation.component.vue?vue&type=template&id=668d1cea&scoped=true&"
import script from "./judgesEvaluation.component.vue?vue&type=script&lang=js&"
export * from "./judgesEvaluation.component.vue?vue&type=script&lang=js&"
import style0 from "./judgesEvaluation.component.vue?vue&type=style&index=0&id=668d1cea&lang=scss&scoped=true&"
import style1 from "./judgesEvaluation.component.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./judgesEvaluation.component.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d1cea",
  null
  
)

export default component.exports